import { createSelector } from "reselect";
import get from "lodash/get";

const getModel = state => state.note.modal.model;
const getModelId = state => state.note.modal.modelId;

const noteSelector = createSelector(
  [state => state, getModel, getModelId],
  (state, model, modelId) => {
    if (model === "quote") {
      return get(state.quotes.quotes, [modelId, "notes"], []);
    }

    return get(state, [model, modelId, "notes"], []);
  }
);

export default noteSelector;
